import { createAction, props } from '@ngrx/store';

import { IAttachment } from '../../chat/interfaces/IAttachment';
import { IUserProfile } from '../interfaces/IUserProfile';
import { UserState } from './user.reducer';

export const setUser = createAction('[Auth] set User', props<{ profileInfo: IUserProfile }>());

export const updateUser = createAction('[Auth] update User', props<{ displayName: string; attachments: IAttachment[] }>());

export const unSetUser = createAction('[Auth] unSet User');

export const loadProfileInfo = createAction('[AUTH] Load Profile Info');

export const setCompleteUserState = createAction('[Auth] Set complete user state', props<{ savedState: UserState }>());

export const sendAway = createAction(
  '[AUTH] Send away',
  props<{
    userId?: string;
    to: Date;
    message?: string;
  }>()
);

export const cancelAway = createAction('[AUTH] cancel away');

export const getHandshake = createAction('[AUTH] get handshake');

export const setCancelAway = createAction('[AUTH] set cancel away');

export const setAway = createAction(
  '[AUTH] set away',
  props<{
    userId: string;
    to: Date;
    message?: string;
  }>()
);

export const getHandshakeSuccess = createAction('[Auth] Get Handshake Success', props<{ token: string }>());
